import React from 'react';
import { FAQS } from '../../data';
import FAQItem from '../molecules/FAQItem';

const FAQSection = () => {
    return (
        <section className="py-32 px-6 md:px-12 bg-[#050505]">
            <h2 className="font-migra text-5xl md:text-6xl mb-20">FAQs</h2>
            <div className="space-y-4">
                {FAQS.map((faq, i) => (
                    <FAQItem key={i} faq={faq} />
                ))}
            </div>
        </section>
    );
};

export default FAQSection;
